import axios from 'axios'
import {useMutation, useQuery, useQueryClient} from 'react-query'
import {toast} from 'react-toastify'
import {API_URL} from 'src/cms/constants/EndPoint'

export const useGetDocuments = (params: any) => {
  const {search, page = 1, limit = 10, orderBy, order = 'asc'} = params
  return useQuery(['GET_DOCUMENTS', params], async () => {
    const {data} = await axios.get(`${API_URL}/documents`, {
      params: {
        search,
        page,
        limit,
      },
    })
    return data
  })
}

export const useGetDocumentsById = (id: string) => {
  return useQuery(
    ['GET_DOCUMENTS_BY_ID', id],
    async () => {
      const {data} = await axios.get(`${API_URL}/documents/${id}`)
      return data
    },
    {
      enabled: !!id,
    }
  )
}

export const useAddDocuments = () => {
  const queryClient = useQueryClient()
  return useMutation(
    async (value: any) => {
      const data = await axios.post(`${API_URL}/documents`, value)
      return data
    },
    {
      onSuccess: (data: any) => {
        if (data?.data?.resCod == 200) {
          queryClient.invalidateQueries('GET_DOCUMENTS')
          toast.success(data?.data?.data?.message || 'Document added successfully')
        }
      },
      onError: (error) => {
        toast.error((error as any)?.data?.message || 'Something went wrong')
      },
    }
  )
}

export const useUpdateDocuments = () => {
  const queryClient = useQueryClient()
  return useMutation(
    async (value: any) => {
      const data = await axios.patch(`${API_URL}/documents/${value?.id}`, value)
      return data
    },
    {
      onSuccess: (data: any) => {
        if (data?.data?.resCod == 200) {
          queryClient.invalidateQueries('GET_DOCUMENTS')
          toast.success(data?.data?.data?.message || 'Document updated successfully')
        }
      },
      onError: (error) => {
        toast.error((error as any)?.data?.message || 'Something went wrong')
      },
    }
  )
}
